import { ProductLoading } from ".";
import { Skeleton } from "../ui/skeleton";

export default function ProductSliderLoader() {
  return (
    <div className="max-w-[1440px] mx-auto">
      <div className="flex justify-between mb-4">
        <Skeleton className={"w-24 h-7"} />
        <Skeleton className={"w-12 h-5"} />
      </div>
      <div className="flex justify-between overflow-hidden">
        {Array.from({ length: 5 }).map((_, index) => (
          <ProductLoading key={index} />
        ))}
      </div>
    </div>
  );
}
